import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from '../BookingInfoConstructor.css';

export function BlockTitle({ children }: { children: string | undefined }) {
  return (
    <div className={styles['block-title']}>
      <UIHeading2>{children}</UIHeading2>
    </div>
  );
}
